import { Text } from '@mantine/core';

import CustomModal from '../Modal';
import modalStyles from '../Modal/Modal.module.scss';

import styles from './ConfirmationModal.module.scss';

export interface ConfirmationModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void; // Called on Cancel button
  title: string;
  description: React.ReactNode;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

const ConfirmationModal = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  title,
  description,
  primaryButtonText = 'Confirm',
  secondaryButtonText = 'Cancel',
  onCancel
}: ConfirmationModalProps) => {
  return (
    <CustomModal
      modalProps={{
        onClose, // X icon closes modal
        opened: isOpen,
        size: 'xl'
      }}
      header={{
        title,
        titleClassName: modalStyles.modalTitleQuiet
      }}
      primaryButton={{
        text: primaryButtonText,
        onClick: onConfirm,
        isLoading
      }}
      secondaryButton={{
        text: secondaryButtonText,
        onClick: onCancel ?? onClose // fallback to onClose if onCancel not provided
      }}>
      <div className={styles.content}>
        <Text fz={14} fw={400} lh={1.5} c="plum.8">
          {description}
        </Text>
      </div>
    </CustomModal>
  );
};

export default ConfirmationModal;
